import { Highlight } from '@tiptap/extension-highlight';
import { Link } from '@tiptap/extension-link';
import { TextStyle } from '@tiptap/extension-text-style';
import { Underline } from '@tiptap/extension-underline';
import { StarterKit } from '@tiptap/starter-kit';

export const richTextEditorExtensions = [
  StarterKit,
  Link.configure({
    openOnClick: true,
    autolink: true,
    HTMLAttributes: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  }),
  Underline,
  TextStyle,
  Highlight,
];
